<div
    class="paragraph"
    [innerHTML]="sanitizer.bypassSecurityTrustHtml(text)"
></div>
